import { Button, Card, Container } from "react-bootstrap";
import BackButton from "../../../shared/BackButton";
import { useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import RiyalSymbol from "../../../assets/images/Saudi_Riyal_Symbol.svg";
import RiyalSymbolGreen from "../../../assets/images/Saudi_Riyal_Symbol_Green.svg";
import useLegacyEffect from "../../../hooks/useLegacyEffect";
import isEmpty from "../../../utils/isEmpty";
import { createOrder } from "../../../store/Consultation/actions";

function InitiateOrder() {
  const navigate = useNavigate();
  let { companyId } = useParams();
  const dispatch = useDispatch();

  const local = useSelector((state) => state.homeReducer.local);
  const selectedPackage = useSelector(
    (state) => state.consultationReducer.selectedPackage
  );
  const handleNextStep = () => {
    dispatch(createOrder(navigate, selectedPackage.id, companyId));
  };
  useLegacyEffect(() => {
    if (isEmpty(selectedPackage)) {
      navigate(-1);
    }
  }, []);
  return (
    <Container>
      <BackButton onClick={() => navigate(-1)} label={local.backV2} />

      <h1 className="mb-4 fs-3">{local.orderReview}</h1>
      <Card className="shadow p-4">
        <div className="d-flex justify-content-between align-items-center mb-2 text-primary fs-6 fw-bold">
          <p className="mb-0">{local.consultationType}</p>
          <p className="mb-0">{local.price}</p>
        </div>

        <div className="line"></div>

        <div className="grid mt-4 justify-content-between align-items-stretch fs-6 fw-medium">
          <p className="mb-0 g-col-12 g-col-md-7 g-col-xl-8">
            {selectedPackage?.description}
          </p>
          <div className="g-col-12 g-col-md-5 g-col-xl-4 justify-content-between total-amount">
            <div className="d-flex w-100 justify-content-between">
              <p className="mb-0">{local.totalWithoutVat}</p>
              <span className="currency mb-0 fs-5 d-flex align-items-center gap-1">
                <img src={RiyalSymbol} alt="SAR" width="16" height="16" />
                {selectedPackage?.price}
              </span>
            </div>
          </div>
        </div>
        <div className="grid mt-4 justify-content-between align-items-stretch fs-6 fw-medium">
          <p className="mb-0 g-col-12 g-col-md-7 g-col-xl-8">
          </p>
          <div className="g-col-12 g-col-md-5 g-col-xl-4 justify-content-between total-amount">
            <div className="d-flex w-100 justify-content-between">
              <p className="mb-0">{local.vat}</p>
              <span className="currency mb-0 fs-5 d-flex align-items-center gap-1">
                <img src={RiyalSymbol} alt="SAR" width="16" height="16" />
                {selectedPackage?.vat_amount}
              </span>
            </div>
          </div>
        </div>

        <div className="line"></div>
        <div className="grid mt-4 review-total justify-content-between align-items-stretch">
          <div className="d-none d-md-block empty g-col-12 g-col-md-7 g-col-xl-8"></div>
          <div className="g-col-12 g-col-md-5 g-col-xl-4 justify-content-between total-amount">
            <div className="d-flex w-100 justify-content-between">
              <p className="fs-5 text-success fw-bold d-inline mb-0">
                {local.totalCost}
              </p>
              <p className="fs-4 text-success fw-bold d-inline mb-0 currency">
                <img
                  src={RiyalSymbolGreen}
                  alt="SAR"
                  width="16"
                  height="16"
                  className="me-1 mb-1"
                />
                {selectedPackage?.grand_total}
              </p>
            </div>
          </div>
        </div>
      </Card>
      <div className="row justify-content-center mt-5 text-center">
        <div className="col-12 col-md-4">
          <Button
            variant="secondary"
            className="w-100 text-white"
            onClick={handleNextStep}
          >
            {local.processToPay}
          </Button>
        </div>
      </div>
    </Container>
  );
}

export default InitiateOrder;
